module.exports = __webpack_public_path__ + "img/monocycle-green-left.86addc4c.jpg";